import { Link } from '@tanstack/react-router';
import { Card } from '../../components/layout/Card';
import { CenteredPage } from '../../components/layout/CenteredPage';

/** In-shell 404: a route that doesn't exist. */
export function NotFoundPage() {
  return (
    <Card>
      <h2 className="m-0 mb-2 font-heading text-[19px] font-bold text-brown-deep">Page not found.</h2>
      <p className="m-0 text-sm text-muted">That address doesn't match a screen.</p>
      <p className="m-0 mt-1 text-sm">
        <Link to="/" className="font-semibold text-link">
          Go to your home screen.
        </Link>
      </p>
    </Card>
  );
}

/**
 * In-shell 403: the screen exists but the signed-in tier can't open it (an
 * Advisor following a link to a non-Money screen). Rendered in place, not a
 * redirect, so the address stays meaningful.
 */
export function ForbiddenPage() {
  return (
    <Card>
      <h2 className="m-0 mb-2 font-heading text-[19px] font-bold text-brown-deep">
        You don't have access to this screen.
      </h2>
      <p className="m-0 text-sm text-muted">Your role can't open it.</p>
      <p className="m-0 mt-1 text-sm">
        <Link to="/" className="font-semibold text-link">
          Go to your home screen.
        </Link>
      </p>
    </Card>
  );
}

/** Root-level 404 — an unknown address outside the signed-in shell. */
export function RootNotFoundPage() {
  return (
    <CenteredPage title="Page not found.">
      <p className="m-0">That address doesn't match a screen.</p>
      <p className="m-0 mt-1">
        <Link to="/" className="font-semibold text-link">
          Go to Mission Control.
        </Link>
      </p>
    </CenteredPage>
  );
}
